import { createSlice } from "@reduxjs/toolkit";

import { getAllPOSUserGroupAction, insertUpdatePOSUserGroupAction, getPOSUserGroupAction, activeInactiveAction } from "../../actions/shop-settings/posUserGroupActions";


import { toast } from 'react-toastify';

const INITIAL_STATE = {
    posUserGroup: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    selectedPosUserGroup: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    activeInactiveDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }


};



const posUserGroupReducer = createSlice({
    name: "POSUserGroup",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetPOSUserGroupDetailsState(state, action) {
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
            state.selectedPOSUserGroup = INITIAL_STATE.selectedPosUserGroup;
        },
    },
    extraReducers: (builder) => {



        // get all posusergroup action start


        builder.addCase(getAllPOSUserGroupAction.fulfilled, (state, action) => {
            state.posUserGroup.data.records = action.payload.data;
            state.posUserGroup.apiMsg.status = action.meta.requestStatus;
            state.posUserGroup.apiMsg.message = "success";
            // not working above  line show error
        });
        builder.addCase(getAllPOSUserGroupAction.pending, (state, action) => {
            state.posUserGroup.data.records = null;
            state.posUserGroup.apiMsg.message = action.meta.requestStatus;
            state.posUserGroup.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllPOSUserGroupAction.rejected, (state, action) => {
            state.posUserGroup.apiMsg.message = action.error.message;
            state.posUserGroup.apiMsg.status = action.meta.requestStatus;
        });

        // get all posusergroup action end



        // insert update posusergroup Action start

        builder.addCase(
            insertUpdatePOSUserGroupAction.fulfilled,
            (state, action) => {

                state.insertUpdateDetails.data = action.payload.data.data;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDetails.apiMsg.message = action.payload.message.message;

                if (!action.payload.newRecord) {
                    let updatedRecord = state.posUserGroup.data.records.map(x => {
                        if (x.id == action.payload.data.data.id) {
                            return action.payload.data.data;
                        }
                        else {
                            return x;
                        }
                    })

                    state.posUserGroup.data.records = updatedRecord;
                }
                else {
                    if (state.posUserGroup.data.records.length) {
                        state.posUserGroup.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        state.posUserGroup.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });

            }
        );
        builder.addCase(
            insertUpdatePOSUserGroupAction.pending,
            (state, action) => {
                //console.log("insertUpdatePOSUserGroupAction pending", action);
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdatePOSUserGroupAction.rejected,
            (state, action) => {
                //   console.log("insertUpdatePOSUserGroupAction rejected", action);
                state.insertUpdateDetails.apiMsg.message = action.error.message;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );


        //   insert update insertUpdatePOSUserGroupAction action end

        //------------------------------- getposUserGroup start -------------------------

        builder.addCase(getPOSUserGroupAction.fulfilled, (state, action) => {
            state.selectedPosUserGroup.data = action.payload.data;
            state.selectedPosUserGroup.apiMsg.status = action.meta.requestStatus;
            state.selectedPosUserGroup.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getPOSUserGroupAction.pending, (state, action) => {
            //console.log("getPOSUserGroupAction pending", action);
            state.selectedPosUserGroup.data = null;
            state.selectedPosUserGroup.apiMsg.message = action.meta.requestStatus;;
            state.selectedPosUserGroup.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getPOSUserGroupAction.rejected, (state, action) => {
            // console.log("getPOSUserGroupAction rejected", action);
            state.selectedPosUserGroup.apiMsg.message = action.error.message;
            state.selectedPosUserGroup.apiMsg.status = action.meta.requestStatus;
        });


        //   get posUserGroup end

        //------------------------------- activeInactiveAction start -------------------------

        builder.addCase(
            activeInactiveAction.fulfilled,
            (state, action) => {
                //console.log("activeInactiveAction", action);

                state.activeInactiveDetails.data = action.payload.data.data;
                state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
                state.activeInactiveDetails.apiMsg.message = action.payload.message.message;

                let updatedRecord = state.posUserGroup.data.records.map(x => {
                    if (x.id == action.meta.arg.id) {
                        x.isActive = action.meta.arg.isActive;
                        return x;
                    }
                    else {
                        return x;
                    }
                })



                state.posUserGroup.data.records = updatedRecord;

                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "success"
                });

            }
        );
        builder.addCase(
            activeInactiveAction.pending,
            (state, action) => {
                state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            activeInactiveAction.rejected,
            (state, action) => {
                state.activeInactiveDetails.apiMsg.message = action.error.message;
                state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "error"
                });
            }
        );

        //------------------------------- activeInactiveAction end -------------------------



    },
});
export const { RESET, ResetPOSUserGroupDetailsState } = posUserGroupReducer.actions;
export default posUserGroupReducer.reducer;